export const SET_SELECTED_LEVEL_1_NAV_SLUG = 'SET_SELECTED_LEVEL_1_NAV_SLUG';
export const SET_SELECTED_LEVEL_2_NAV_SLUG = 'SET_SELECTED_LEVEL_2_NAV_SLUG';

export function setSelectedLevel1NavSlug(slug) {
    return {
        type: SET_SELECTED_LEVEL_1_NAV_SLUG,
        payload: {
            slug: slug
        }
    };
}

export function setSelectedLevel2NavSlug(slug) {
    return {
        type: SET_SELECTED_LEVEL_2_NAV_SLUG,
        payload: {
            slug: slug
        }
    };
}
